<p-dialog header="Post Info Pack Chart" (onHide)="closeDialog()" [(visible)]="displayModal" [modal]="true"
    [style]="{width: '82vw'}" [draggable]="false" [resizable]="false">
  <p-chart type="bar" [data]="data"></p-chart>
</p-dialog>